/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  GenericTableData
} from '../../model/genericTableData'
import type {
  ReportingRunCreateDataRequest
} from '../../model/reportingRunCreateDataRequest'
import type {
  ReportingRunReadData
} from '../../model/reportingRunReadData'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Create a new reporting run
 */
export const reportingRunCreate = (
    reportingRunCreateDataRequest: ReportingRunCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<ReportingRunReadData>(
      {url: `/reports/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportingRunCreateDataRequest
    },
      options);
    }
  


export const getReportingRunCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportingRunCreate>>, TError,{data: ReportingRunCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof reportingRunCreate>>, TError,{data: ReportingRunCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reportingRunCreate>>, {data: ReportingRunCreateDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  reportingRunCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReportingRunCreateMutationResult = NonNullable<Awaited<ReturnType<typeof reportingRunCreate>>>
    export type ReportingRunCreateMutationBody = ReportingRunCreateDataRequest
    export type ReportingRunCreateMutationError = unknown

    export const useReportingRunCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportingRunCreate>>, TError,{data: ReportingRunCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getReportingRunCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets all available reports
 */
export const availableReportTableRetrieve = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/reports/available/`, method: 'GET', signal
    },
      options);
    }
  

export const getAvailableReportTableRetrieveQueryKey = () => {
    return [`/reports/available/`] as const;
    }

    
export const getAvailableReportTableRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof availableReportTableRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof availableReportTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAvailableReportTableRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof availableReportTableRetrieve>>> = ({ signal }) => availableReportTableRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof availableReportTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AvailableReportTableRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof availableReportTableRetrieve>>>
export type AvailableReportTableRetrieveQueryError = unknown

export const useAvailableReportTableRetrieve = <TData = Awaited<ReturnType<typeof availableReportTableRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof availableReportTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAvailableReportTableRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAvailableReportTableRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof availableReportTableRetrieve>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof availableReportTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAvailableReportTableRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof availableReportTableRetrieve>>> = ({ signal }) => availableReportTableRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof availableReportTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AvailableReportTableRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof availableReportTableRetrieve>>>
export type AvailableReportTableRetrieveSuspenseQueryError = unknown

export const useAvailableReportTableRetrieveSuspense = <TData = Awaited<ReturnType<typeof availableReportTableRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof availableReportTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAvailableReportTableRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getAvailableReportTableRetrieveLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getAvailableReportTableRetrieveQueryKey(),
          queryFn: () => availableReportTableRetrieve(),
        }).then(() => null));
      /**
 * Gets all historical reports data
 */
export const historicalReportTableRetrieve = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/reports/historical/`, method: 'GET', signal
    },
      options);
    }
  

export const getHistoricalReportTableRetrieveQueryKey = () => {
    return [`/reports/historical/`] as const;
    }

    
export const getHistoricalReportTableRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof historicalReportTableRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof historicalReportTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHistoricalReportTableRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof historicalReportTableRetrieve>>> = ({ signal }) => historicalReportTableRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof historicalReportTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HistoricalReportTableRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof historicalReportTableRetrieve>>>
export type HistoricalReportTableRetrieveQueryError = unknown

export const useHistoricalReportTableRetrieve = <TData = Awaited<ReturnType<typeof historicalReportTableRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof historicalReportTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHistoricalReportTableRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHistoricalReportTableRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof historicalReportTableRetrieve>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof historicalReportTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHistoricalReportTableRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof historicalReportTableRetrieve>>> = ({ signal }) => historicalReportTableRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof historicalReportTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HistoricalReportTableRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof historicalReportTableRetrieve>>>
export type HistoricalReportTableRetrieveSuspenseQueryError = unknown

export const useHistoricalReportTableRetrieveSuspense = <TData = Awaited<ReturnType<typeof historicalReportTableRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof historicalReportTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHistoricalReportTableRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getHistoricalReportTableRetrieveLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getHistoricalReportTableRetrieveQueryKey(),
          queryFn: () => historicalReportTableRetrieve(),
        }).then(() => null));
      